import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store/store';
import StickyBuildInfo from './components/StickyBuildInfo';
import 'bootstrap-icons/font/bootstrap-icons.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
      <App />
      <span className="fixed bottom-4 right-10 z-20">
        <StickyBuildInfo />
      </span>
    </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
